export function Otp({
    loading,
	values,
	onKeyUpOtpInput,
	onPaste
}) {
    return (
        <div className="doca-flex doca-justify-center doca-items-center doca-mb-5">
            <div className="doca-form__field doca-form__field--otp ">
                <input
                    className="doca-form-control doca-form-control--otp opt-dimetions"
                    type="tel"
                    id="otp0"
                    onKeyUp={(e) => onKeyUpOtpInput(e, 0)}
                    onPaste={onPaste}
                    name="otp0"
                    value={values['otp0']}
                    disabled={loading}
                    maxLength={1}
                />
                <input
                    className="doca-form-control doca-form-control--otp opt-dimetions"
                    type="tel"
                    id="otp1"
                    onKeyUp={(e) => onKeyUpOtpInput(e, 1)}
                    onPaste={onPaste}
                    name="otp1"
                    value={values['otp1']}
                    disabled={loading}
                    maxLength={1}
                />
                <input
                    className="doca-form-control doca-form-control--otp opt-dimetions"
                    type="tel"
                    id="otp2"
                    onKeyUp={(e) => onKeyUpOtpInput(e, 2)}
                    onPaste={onPaste}
                    name="otp2"
                    value={values['otp2']}
                    disabled={loading}
                    maxLength={1}
                />
                <input
                    className="doca-form-control doca-form-control--otp opt-dimetions"
                    type="tel"
                    id="otp3"
                    onKeyUp={(e) => onKeyUpOtpInput(e, 3)}
                    onPaste={onPaste}
                    name="otp3"
                    value={values['otp3']}
                    disabled={loading}
                    maxLength={1}
                />
                <input
                    className="doca-form-control doca-form-control--otp opt-dimetions"
                    type="tel"
                    id="otp4"
                    onKeyUp={(e) => onKeyUpOtpInput(e, 4)}
                    onPaste={onPaste}
                    name="otp4"
                    value={values['otp4']}
                    disabled={loading}
                    maxLength={1}
                />
            </div>
        </div>
    );
};
